import { Outlet } from 'react-router';
import { ErrorBoundary } from 'components/common/ErrorBoundary/ErrorBoundary';
import { StartupSuspense } from 'components/common/StartupSuspense/StartupSuspense';
import { useGetLanguagesQuery } from 'store/features/settings/settings-api';

const AppLayout = () => {
  useGetLanguagesQuery(undefined, {
    // Keep app-level reference data warm in RTK Query cache for every route.
    selectFromResult: () => ({}),
  });

  return (
    <ErrorBoundary>
      <StartupSuspense>
        <Outlet />
      </StartupSuspense>
    </ErrorBoundary>
  );
};

export default AppLayout;
